// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../isAfter/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var isAfter = convertToFP(fn, 2);
export default isAfter;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/isAfter/index.js
// module id = 918
// module chunks = 0